module.exports = __webpack_public_path__ + "static/media/sustainable_about.b1e3b597.png";